import React from "react"
import { Button } from "@bw/bits"
import * as resolvers from "@bw/modules/resolvers"

const Header = ({ modules, page, breadcrumbsLinks }) => {
  if (!modules) {
    return null
  }

  return modules
    .filter(module => module !== null)
    .map((module, i) => {
      const LoadedModule = resolvers[module.__typename.replace("Module", "")]
      if (typeof LoadedModule === "undefined") {
        return null
      }

      module.breadcrumbs = breadcrumbsLinks

      if (!module.title) {
        module.title = page.title
      }

      return <LoadedModule key={i} {...module} />
    })
}

const Content = ({ modules, childNodes, location }) => {
  if (!modules) {
    return null
  }

  return modules
    .reduce((acc, item) => {
      if (item === null) {
        // if the module is empty for any reason, we just skip it
        return acc
      }

      if (
        item.__typename === "PredefinedModuleModule" &&
        item?.module?.content
      ) {
        // this is a predefined module, so we grab the modules inside it
        // and put them in line with others
        acc = [...acc, ...item.module.content]
      } else {
        acc.push(item)
      }

      return acc
    }, [])
    .map((module, i, allModules) => {
      const LoadedModule = resolvers[module.__typename.replace("Module", "")]
      if (typeof LoadedModule === "undefined") {
        return null
      }

      if (module.buttonType?.value === "url" && module.buttonUrl) {
        module.button = (
          <Button
            label={module.buttonText}
            href={module.buttonUrl}
            external={module.buttonIsExternal}
            modal={module.buttonOpenInModal}
            primary
          />
        )
      }

      if (module.buttonType?.value === "entry" && module.buttonEntry) {
        module.button = (
          <Button
            label={module.buttonText}
            to={module.buttonEntry.url}
            primary
          />
        )
      }

      const moduleProps = {
        ...module,
        childNodes,
        location,
        buttonPosition: module.buttonPosition?.value,
      }

      // check if the next module has the backgroundVariant
      moduleProps.isFollowedByModuleWithBackgroundVariant =
        typeof allModules[i + 1] !== "undefined" &&
        allModules[i + 1].backgroundVariant

      // add module classname for customisation
      if (moduleProps.classAttribute) {
        moduleProps.classAttribute = `section--${module.__typename.toLowerCase()} ${
          moduleProps.classAttribute
        }`
      } else {
        moduleProps.classAttribute = `section--${module.__typename.toLowerCase()}`
      }

      return <LoadedModule key={i} {...moduleProps} />
    })
}

export { Header, Content }
